import {initWebComponent} from "@/helpers/web-component-helper";
import {zoomIn} from "@/helpers/ol-event-helper";

const template = document.createElement('template');

export class OlZoomInComponent extends HTMLElement {
    constructor() {
        super();

        template.innerHTML = `
        <button class="btn btn-outline-secondary icon-btn rounded-pill btn-footer" id="btnZoomIn">
          <span class="fa fa-plus"></span>
        </button>`

        initWebComponent(this, template)

        this.addEventListener('click', (element) => {
            zoomIn()
        })
    }
}
